import { getRequest, patchRequest } from 'services/requests';

export default {
    loginUser: (username, password) => getRequest('/users', { username, password }),
    findUser: (id) => getRequest(`/users/${id}`),
    findAccount: (id) => getRequest(`/users/${id}/accounts`),
    findGroupAccounts: (id) => getRequest(`/groups/${id}/accounts`),
    findGroupUsers: (id) => getRequest(`/groups/${id}/users`),
    // findCourseAccounts: (id) => getRequest(`/course/${id}/accounts`),
    // findCourseUsers: (id) => getRequest(`/course/${id}/users`),
    listCourseAccounts: (id) => getRequest(`/course/${id}/accounts`),
    listCourseUsers: (id) => getRequest(`/course/${id}/users`),
    updateUser: (id, body) => patchRequest(`/users/${id}`, body),
    updateGroupAccount: (id, body) => patchRequest(`/accounts/${id}`, body),
    updateGroupUser: (id, body) => patchRequest(`/accounts/${id}`, body),
};
